/* eslint-disable no-unused-vars */
/* eslint-disable default-param-last */
const initialState = {
  values: [],
  isEdited: false,
  type: null,
  action: null,
};
const missionReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'ADD_MISSION':
      return {
        ...state,
        values: payload,
      };
    case 'DEL_MISSION':
      return {
        ...state,
        values: [],
        isEdited: false,
      };
    case 'EDITED_MISSION':
      return {
        ...state,
        isEdited: payload,
      };
    case 'SET_TYPE_MISSION':
      return {
        ...state,
        type: payload,
      };
    case 'SET_ACTION_MISSION':
      return {
        ...state,
        action: payload,
      };
    case 'ADDED_MISSION':
      return {
        ...state,
        isAdded: payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default missionReducer;
